// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"863":"f6192bf4","952":"4df21e79","988":"2100dd4d"}[chunkId] + ".chunk.js";
};